import(/* webpackMode: "eager" */ "/codebuild/output/src3078231438/src/pixelated-tech/apps/pixelated/src/app/(pages)/(home)/page.tsx");
